import request from "@/utils/request";

//统计用户、车辆、企业总数
export function homeStatNum(data) {
  return request({
    url: "/adminApi/home/statistics",
    data: data,
    method: "post"
  })
}

//查询缴费提醒数量
export function homeRemindCount() {
  return request({
    url: '/adminApi/home/remindCount',
    method: "post"
  })
}

//岗前培训饼状图
export function homePie() {
  return request({
    url: "/adminApi/home/preJobTrainingData",
    method: "post"
  })
}

//首页日常安全学习统计
export function homeBar() {
  return request({
    url: "/adminApi/home/dailySafetyLearning",
    method: "post"
  })
}


//费用管理的泡泡
export function homeRemind() {
  return request({
    url: "/adminApi/home/remind",
    method: "post"
  })
}
